import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import { useModal } from "../contexts/ModalContext";
import Content from "../Modulos/Checklist/Body/Content";

const CheckListHome = () => {

    const { openModal } = useModal();

    const abrirMenuLateral = () => {

        openModal("sidebarChecklist")

    }

    const abrirFiltrosMobile = () => {

        openModal("checklistFiltersMobile");

    }

    return(
        <>
            <NavBar
                title="CHECKLIST"
                setSideBar={ abrirMenuLateral }
                onFilterClick={ abrirFiltrosMobile }
                goBackOnePage
            />
            <GenericBody>
                <Content />
            </GenericBody>
        </>
    )

}

export default CheckListHome;